import { createStructuredSelector } from 'reselect'

const schedules = ({ schedules }) => schedules.getIn(['schedulesList'], [])
const loading = ({ schedules }) => schedules.getIn(['loading'], false)

export default createStructuredSelector({
  loading,
  schedules
})
